<template>
    <v-menu
        ref="calendarMenu"
        v-model="calendarMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px">
        <template v-slot:activator="{ on }">
        <v-text-field dense outlined
                v-model="computed_model"
                append-icon="event"
                v-on="on"
                readonly
                @click:clear="resetValue"
                v-bind="computedProps"
            ></v-text-field>
        </template>
        <v-date-picker 
            v-model="model" 
            :min="min"
            :max="max"
            no-title
            @input="calendarMenu = false">
        </v-date-picker>
    </v-menu>
</template>

<script>
    import { VTextField, VDatePicker } from 'vuetify/lib';
    import { getTimestamp, formatDatefromTS } from '../../utils/commonUtils'

    export default {
        components: { VDatePicker },
        name: 'CalendarField',
        extends: VTextField,

        props: {
            minDate: {
                type: Number,
                default: 172800000
            },
            maxDate: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                timestamp: this.value,
                model: null,
                computed_model: "",
                calendarMenu: false,
            }
        },
        mounted() {
            this.setDateModel()
        },
        beforeDestroy() {
        },
        watch: {
            timestamp: function(val) {
                this.$emit('input', val)
            },
            model: function(val) {
                if (!val) {
                    this.timestamp = null
                    this.computed_model = ''
                    return
                } 
                this.timestamp = getTimestamp(val)
                this.computed_model = formatDatefromTS(this.timestamp)
          
            },
            value: function(val){
                this.timestamp = val
                this.setDateModel()
            }
        },
        methods: {
            setDateModel () {
                if (!this.timestamp){
                  this.model = ""
                  return
                }
                this.model = (new Date(this.timestamp)).toISOString().substr(0, 10)
            },
            resetValue(){
                this.timestamp = null
                this.$emit('change')
            }
        },
        computed: {
            computedProps() {
                return {
                    value: this.timestamp,
                    ...this.$props,
                }
            },
            min() {
                let min = null
                if (this.minDate) {
                    min = (new Date(this.minDate).toISOString()).substr(0,10)
                }
                return min
            },
            max() {
                let max = null
                if (this.maxDate) {
                    max = (new Date(this.maxDate).toISOString()).substr(0,10)
                }
                return max
            }
        }
    }
</script>